module.exports = __webpack_public_path__ + "static/self-design-2-33ab7347f86a7036fdec64698b4a8361.png";